export const I18N = {
  defaultLocale: "en-GB",
  enabledLocales: ["en-GB", "en-US", "it-IT", "fr-FR", "nl-NL", "pl-PL", "pt-BR"],
};

export const brand = {
  footer: {
    url: "https://steemscan.com/account/future.witness",
    text: "Futureshock",
  },
};

export const knownAccountsList =
  "https://raw.githubusercontent.com/FutureShockco/steemofficialaccounts/master/known-accounts.json";

export const knownSeedsList =
  "https://api.steemscan.com/seeds/status";

export const knownRpcsList =
  "https://raw.githubusercontent.com/FutureShockco/steemofficialaccounts/master/known-rpcs.json";

  export const knownAppsList =
  "https://raw.githubusercontent.com/FutureShockco/steemofficialaccounts/master/known-dapps.json";
